import React from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

const Navbar = () => {
  return (
    <nav className='navbar'>
        <ul>
            <Link to={'/home'}> <li>Home</li></Link>
            <HashLink to={'/home#aboutMe'}> <li>About Me</li></HashLink>
            <HashLink to={'/home#techStack'}> <li>Tech Stack</li></HashLink>
            <HashLink to={'/home#projects'}>  <li>Projects</li></HashLink>
           
            
           
        </ul>
    </nav>
  )
}

export default Navbar